import { IRadioButtonChipOptions } from '@components/common/formControl/radioButtonChip';

export * from './siteListFilters';

export const ContractorTypeFilterLabel = {
	FCC_Contractor: 'fcc-contractor',
	Non_FCC_Contractor: 'non-fcc-contractor',
	No_Contractor: 'no-contractor',
	Adopted: 'adopted_contractor',
	Non_Aopted_Contractor: 'non-adopted-contractor',
};

export const contractorTypeFilterList: IRadioButtonChipOptions[] = [
	{ id: 1, label: 'FCC Contractor', value: ContractorTypeFilterLabel.FCC_Contractor },
	{ id: 2, label: 'Non-FCC Contractor', value: ContractorTypeFilterLabel.Non_FCC_Contractor },
	{ id: 4, label: 'Adopted', value: ContractorTypeFilterLabel.Adopted },
	{ id: 5, label: 'Non-adopted Contractor', value: ContractorTypeFilterLabel.Non_Aopted_Contractor },
	{ id: 3, label: 'No Contractor', value: ContractorTypeFilterLabel.No_Contractor },
];
